// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__iG1K8","list":"styles_list__1nTnj"};